import { RadioButtonBase } from '@/common/components/RadioButton/RadioButtonBase/RadioButtonBase';
import { RadioButtonGroup } from '@/common/components/RadioButton/RadioButtonGroup/RadioButtonGroup';
import { RadioButtonOption } from '@/common/components/RadioButton/RadioButtonOption/RadioButtonOption';

export const RadioButton = {
  Group: RadioButtonGroup,
  Option: RadioButtonOption,
  Base: RadioButtonBase,
};
